import React, { useState, useEffect } from 'react';
import { Button, Menu, Dropdown } from 'antd';

import {
    MenuOutlined,
} from '@ant-design/icons';
import { JSXMap, publish } from '../Tool';
import { useAuth } from '../Auth';
import { Action } from '../Action';

import uuid from 'react-uuid';

export default function DropdownAction(props) {
    const { button, menuOptions, items } = props;
    const auth = useAuth();
    const [actions, setActions] = useState([]);
    useEffect(()=>{
        if(items){
            // console.log(items);
            setActions(items.filter(e=>!!e).map(e=>({...e, uuid: uuid()})))
        }
    },[items])
    
    const btn = () => {
        if (button) {
            return button();
        } else {
            return (<Button size={"small"} style={{ padding: "0 6px" }} type="default">
                <MenuOutlined />
            </Button>);
        }
    };

    // {
    //     title: "Изменить",
    //     modal: {
    //         title: "Изменить услугу на мероприятии",
    //     },
    //     action: {
    //         method: "POST",
    //         path: "/api/tariftemplate/update",
    //         mutation: "update",
    //         onValues: (values, context) => {
    //             return { ...values, ID: item.ID, meropriyatieID: object.ID }
    //         },
    //         onClose: ({unlock, close}, context) => close()
    //     },
    //     form: IzmenitTarifTemplate,
    //     sourceKey: sourceKey,
    //     queryFilterContext: queryFilterContext,
    // }

    // var subscriber = function (msg, data) {
    //     console.log(msg, data)
    // };
    // var token = PubSub.subscribe('action.0.click', subscriber);

    return (
        <div>
            {JSXMap(actions, (e, idx) => (<div key={idx}>
                <Action
                    key={e.key || idx}
                    auth={auth}
                    mode={"MenuItem"}
                    object={e}
                    {...e}
                    // trigger={(click) => { }}
                />
            </div>))}
            <Dropdown trigger={['click']} {...props} overlay={
                <Menu {...menuOptions} selectable={false} items={(actions && actions.length) ? actions.map((e, idx) => ({
                    key: e.uuid,
                    label: e.title || ((e.modal) ? e.modal.title : "")
                })) : []} onClick={(e) => {
                    if(e.key){
                        publish(`action.${e.key}.click`, e.key);
                    }
                }}>
                    {/* {childrenWithProps.map((item) => item)} */}
                </Menu>}>
                {btn()}
            </Dropdown>
        </div>
    );
};

